
import { httpApi } from "./http.api";

export const submitCandidateSendEmail = async (candidateSendEmailPayload: any): Promise<any> => {
  const { data } = await httpApi.post<any>("/users/mail/send-mail/", candidateSendEmailPayload);
  return data;
};

export const addEventBulkMail = async (payload: any): Promise<any> => {
  const { data } = await httpApi.post<any>("/bulkemail/bulk-email/initiate-bulk-email/", payload);
  return data;
};

export const addDummyEventBulkMail = async (payload: any): Promise<any> => {
  const { data } = await httpApi.post<any>("/bulkemail/bulk-email/-bulk-email/", payload);
  return data;
};

export const getEmailTemplates = (): Promise<any> =>
  httpApi.get("/users/email-template/").then(({ data }) => data);

export const ReplyToMail = async (payload: any): Promise<any> => {
  const { data } = await httpApi.post<any>("/email_tracking/reply-to-thread/", payload);
  return data;
};

export const ShareEmailTemplate = async (payload: any): Promise<any> => {
  const data = await httpApi.post<any>("/users/share-email-template/add-contributors/", payload);
  return data;
};

export const fetchAllContributorsForTemplate = (jobId: number): Promise<any> =>
  httpApi
    .get<any>(`users/share-email-template/get-all-team-members/?resource_id=${jobId}`)
    .then(({ data }) => data);
